import {
  InternalAdTrackingData,
  InternalAdTrackingDataParams,
} from "@shared/services/event_tracking/entities/ads/internal_ad_tracking_data";

interface BannerAdEntityParams extends InternalAdTrackingDataParams {
  product_line_ids: number[];
  slot_id: string;
}

export class BannerAdEntity extends InternalAdTrackingData {
  product_line_ids: number[];
  slot_id: string;

  constructor(params: BannerAdEntityParams) {
    super(params);
    this.type = "banner_ad";
    this.entity_version = 3;
    this.product_line_ids = params.product_line_ids;
    this.slot_id = params.slot_id;
  }
}
